import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import ORSMActivationFailed from './ORSMActivationFailed';
import { Size } from '../../../../Enums/Size.enum';

const ORSMActivationFailedModal: React.FC<BaseModalProps> = props => {
	return (
		<BaseModal
			{...props}
			title='component.ORSMActivationFailed.modalTitle'
			headerEnabled={false}
			size={Size.MD}>
			<ORSMActivationFailed onClose={props.onClose} />
		</BaseModal>
	);
};

export default ORSMActivationFailedModal;
